// ════════════════════════════════════════════════════════════════════════════
// useFieldId — gera id único e estável para form fields
// Pack DS · Primitivos Lpa*
// ════════════════════════════════════════════════════════════════════════════

import { useId } from "react";

/**
 * Gera id único + auxiliares para um form field.
 * Garante que label/hint/error fiquem corretamente associados ao input via ARIA.
 *
 * @param explicitId — Se fornecido, usa esse id. Senão, gera via useId().
 */
export function useFieldId(explicitId?: string): {
  fieldId: string;
  labelId: string;
  hintId: string;
  errorId: string;
} {
  const auto = useId();
  const fieldId = explicitId ?? `lpa-${auto}`;
  return {
    fieldId,
    labelId: `${fieldId}-label`,
    hintId: `${fieldId}-hint`,
    errorId: `${fieldId}-error`,
  };
}
